import { render, staticRenderFns } from "./MapeamentoPerfil.vue?vue&type=template&id=5b12e173&scoped=true&"
import script from "./MapeamentoPerfil.vue?vue&type=script&lang=js&"
export * from "./MapeamentoPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MapeamentoPerfil.vue?vue&type=style&index=0&id=5b12e173&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12e173",
  null
  
)

export default component.exports